import {
  cloneBlueprintBlocks,
  type EmailTemplateBlock,
  type TemplateCategory,
} from '@marketing-hub/shared';

export type { EmailTemplateBlock };

export function emptyParagraphBlock(): EmailTemplateBlock {
  return { type: 'paragraph', text: '' };
}

export function defaultStarterBlocks(category: TemplateCategory = 'cold_outreach'): EmailTemplateBlock[] {
  return cloneBlueprintBlocks(category);
}

export function moveBlock(blocks: EmailTemplateBlock[], index: number, dir: -1 | 1): EmailTemplateBlock[] {
  const next = index + dir;
  if (next < 0 || next >= blocks.length) return blocks;
  const copy = [...blocks];
  const tmp = copy[index]!;
  copy[index] = copy[next]!;
  copy[next] = tmp;
  return copy;
}

export function removeBlockAt(blocks: EmailTemplateBlock[], index: number): EmailTemplateBlock[] {
  if (blocks.length <= 1) return blocks;
  return blocks.filter((_, i) => i !== index);
}

export function updateBlockAt(
  blocks: EmailTemplateBlock[],
  index: number,
  block: EmailTemplateBlock,
): EmailTemplateBlock[] {
  return blocks.map((b, i) => (i === index ? block : b));
}

export function insertBlockAfter(
  blocks: EmailTemplateBlock[],
  index: number,
  block: EmailTemplateBlock,
): EmailTemplateBlock[] {
  const copy = [...blocks];
  copy.splice(index + 1, 0, block);
  return copy;
}
